import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../inventory-category-list/model/category-list.constants";
import { createInventoryCategory } from "./category-create.component.service";
import CategoryTemplateCreateComponent from "./category-create-template.component";
import { getInventoryCategoryInputs } from "../model/inventory-category.modal";
import { tableColumn } from "@screens/bug-tracker/bug-tracker-list/model/bug-tracker-list.constants";
const {
  ALERT_TYPES: { SUCCESS, ERROR },
  CATEGORY_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const InventoryCategoryCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });
  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };
  const [tableData, setTableData] = useState([]);

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let categoryPayload = {};
    for (let i = 0; i < values.length; i++) {
      categoryPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const categoryResponse = await createInventoryCategory(categoryPayload);

    // INFO : check api response and show relevant alert message
    if (categoryResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: categoryResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getInventoryCategoryInputs({}),
    tableData,
    tableColumn,
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <CategoryTemplateCreateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default InventoryCategoryCreateComponent;
